import { resolvePaginationLimit } from "./paginationSettings";

/**
 * Canonical pagination metadata for every product grid.
 * `totalProducts` is the full filtered result count, never the page length.
 */
export const buildProductPagination = ({
  skip = 0,
  limit = 12,
  size = 0,
  totalProducts = 0,
} = {}) => {
  const safeLimit = resolvePaginationLimit(limit, 12);
  const safeSkip = Math.max(Number.parseInt(skip, 10) || 0, 0);
  const safeSize = Math.max(Number.parseInt(size, 10) || 0, 0);
  const safeTotal = Math.max(Number.parseInt(totalProducts, 10) || 0, 0);
  const hasData = safeSize > 0 && safeTotal > 0;

  return {
    skip: safeSkip,
    limit: safeLimit,
    size: safeSize,
    totalProducts: safeTotal,
    totalPages: safeTotal > 0 ? Math.ceil(safeTotal / safeLimit) : 0,
    currentPage: hasData ? Math.floor(safeSkip / safeLimit) + 1 : 0,
    start: hasData ? safeSkip + 1 : 0,
    end: hasData ? Math.min(safeSkip + safeSize, safeTotal) : 0,
    hasPreviousPage: safeSkip > 0,
    hasNextPage: safeTotal > safeSkip + safeLimit,
  };
};

